import { useMemo, useRef } from "react";
import { graphql, useFragment, useSubscription } from "react-relay";
import { WidgetList, WidgetListRef } from "widgets/src/WidgetList";
import { ListFocus_listWidget$key } from "./__generated__/ListFocus_listWidget.graphql";
import { ListFocusScrollSubscription } from "./__generated__/ListFocusScrollSubscription.graphql";

export const ListFocus = (props: { widget: ListFocus_listWidget$key }) => {
  const widget = useFragment(
    graphql`
      fragment ListFocus_listWidget on WidgetList {
        id
        ...WidgetList_widgetList
      }
    `,
    props.widget
  );

  const ref = useRef<WidgetListRef>(null);

  useSubscription<ListFocusScrollSubscription>(
    useMemo(
      () => ({
        subscription: graphql`
          subscription ListFocusScrollSubscription($widgetId: ID!) {
            widgetFocusScrollChanged(widgetId: $widgetId)
          }
        `,
        variables: { widgetId: widget.id },
        onNext: (data) => {
          if (data?.widgetFocusScrollChanged)
            ref.current?.scrollTo(data.widgetFocusScrollChanged);
        },
      }),
      [widget.id]
    )
  );

  return <WidgetList ref={ref} widget={widget} mode="IDLE" />;
};
